import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  exportJobsQueryOptions,
  importJobsQueryOptions,
  ImportsExportsPage,
  importsExportsSearchSchema,
  jobListParams,
} from '@/features/imports-exports';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/imports-exports')({
  staticData: { crumb: 'common:nav.importsExports', tours: ['settings.imports-exports'] },
  // Typed input, so links elsewhere (store settings, the list pages' Import and Export buttons)
  // need not spell out every list param indexSearchSchema declares.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    importsExportsSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, ['exports.run', 'imports.run'], 'any');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = (
      deps.tab === 'imports'
        ? context.queryClient.query({
            ...importJobsQueryOptions(params.storeId, jobListParams(deps, 'imports')),
            staleTime: 'static',
          })
        : context.queryClient.query({
            ...exportJobsQueryOptions(params.storeId, jobListParams(deps, 'exports')),
            staleTime: 'static',
          })
    ).catch(() => undefined);
    // A filter, sort or page change on the list itself must not wait for the fetch: the URL
    // would lag behind, and a second pick in the filter would build on the stale filters.
    if (cause !== 'stay') await prefetch;
  },
  component: ImportsExportsPage,
});
